import { Attachment } from './attachments.model';
import { BibliographyDto } from './BibliographyDto';
import { FlowchartNodeDto } from './FlowchartNodeDto';
import { GuidelineTag } from './guideline-tag.model';
import { GuidelineChapterType } from './GuidelineChapterType';
import { GuidelineComponentDto } from './GuidelineComponentDto';
import { GuidelineLinkDto } from './GuidelineLinkDto';
import { Reference } from './reference.model';
import { ResourceTag } from './widgets/resource-tag.model';

export type GuidelineChapterLocalChanges = {
  description?: string;
  descriptionBelow?: string;
  localAttachments?: Attachment[];
  tag?: GuidelineTag;
  deletedOriginalAttachmentIds?: string[];
  deletedOriginalDescriptionReferenceIds?: string[];
  deletedOriginalDescriptionBelowReferenceIds?: string[];
};

export enum ComponentExpandStrategy {
  Default = 1,
  Expanded = 2,
  Collapsed = 3,
}

export type GuidelineChapter = {
  id?: string | null;
  uniqueId?: string;
  parentChapterId?: string | null;
  parentId?: string | null;
  title?: string;
  description?: string;
  descriptionBelow?: string;
  children?: GuidelineChapter[];
  attachments?: Attachment[];
  bibliographies?: BibliographyDto[];
  guidelineComponents?: GuidelineComponentDto[];
  componentExpandStrategyOnRead?: ComponentExpandStrategy;
  type?: GuidelineChapterType;
  tag?: GuidelineTag;
  references?: Reference[];
  links?: GuidelineLinkDto[];
  descriptionReferences?: Reference[];
  descriptionBelowReferences?: Reference[];
  localChanges?: GuidelineChapterLocalChanges;
  flowchartElements?: FlowchartNodeDto[];
  localFlowchartElements?: FlowchartNodeDto[];
};

// Extract the keys you want to remove
type OmittedGuidelineChapterKeys =
  | 'parentChapterId'
  | 'parentId'
  | 'children'
  | 'description'
  | 'descriptionBelow'
  | 'descriptionReferences'
  | 'descriptionBelowReferences'
  | 'flowchartElements'
  | 'guidelineComponents'
  | 'localFlowchartElements';

// Use the extracted keys in Omit
export type NewGuidelineChapter = Omit<GuidelineChapter, OmittedGuidelineChapterKeys> & {
  children?: NewGuidelineChapter[];
  descriptionWidgetId?: string;
  descriptionBelowWidgetId?: string;
  flowchartWidgetId?: string;
  componentListWidgetId?: string;
  no?: string;
  resourceTags?: ResourceTag[];
};
